export default __webpack_public_path__ + "static/media/Rubix.69274949.png";